"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _classesModel = require('../classes/Model');

var _classesModel2 = _interopRequireDefault(_classesModel);

var _Track = require('./Track');

var _Track2 = _interopRequireDefault(_Track);

var _Artist = require('./Artist');

var _Artist2 = _interopRequireDefault(_Artist);

var Album = (function (_Model) {
    _inherits(Album, _Model);

    function Album(data) {
        _classCallCheck(this, Album);

        _get(Object.getPrototypeOf(Album.prototype), 'constructor', this).call(this, data);
        this.simplified = !data.artists;
    }

    /**
    * protect attributes from mass assigment
    */

    _createClass(Album, [{
        key: 'cover',
        get: function get() {
            return this.images && this.images.length > 0 ? this.images[0].url : '';
        }
    }, {
        key: 'tracks',
        get: function get() {
            var retVal = [];
            if (this.rawData) {
                var trackCollection = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.rawData.tracks.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var trackData = _step.value;

                        trackCollection.push(new _Track2['default'](trackData));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator['return']) {
                            _iterator['return']();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                retVal = trackCollection;
            }
            return retVal;
        }
    }, {
        key: 'artists',
        get: function get() {
            var retVal = [];
            if (!this.simplified) {
                var artistsCollection = [];
                var artists = this.rawData.artists.length > 0 ? this.rawData.artists : this.rawData.artists.items;

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = artists[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var artistData = _step2.value;

                        artistsCollection.push(new _Artist2['default'](artistData));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                            _iterator2['return']();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                retVal = artistsCollection;
            } else {
                console.warn("Simplified Album (%s) doesn't have artists. Make album.get() before request album.artists attribute. See https://developer.spotify.com/web-api/endpoint-reference/", this.name);
            }
            return retVal;
        }
    }], [{
        key: '_getNotFillable',
        value: function _getNotFillable() {
            return ['artists', 'tracks'];
        }
    }, {
        key: '_getType',
        value: function _getType() {
            return 'albums';
        }
    }]);

    return Album;
})(_classesModel2['default']);

exports['default'] = Album;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/entities/Album.js
 ** module id = 102
 ** module chunks = 0
 **/